import axios from 'axios';
import Common from './Common';
export default {
    // getAll() {
    //     return axios.get(Common.api + 'seller-login');
    // },
    getService() {
        return axios.get(Common.api + 'get-service-top');
    },
    getAllProducts(id) {
        return axios.get(Common.api + 'get-for-edit/' + id);
    },
    saveReview(data) {
        return axios.post(Common.api + 'review', data)
    },
    getReview(id, i) {
        return axios.get(Common.api + 'get-all-review/' + id + '/' + i);
    },
    getProducts(id, i, f) {
        return axios.get(Common.api + 'seller-product/' + id + '/' + i + '/' + f);
    },
    getProductsImage(id, i, j) {
        return axios.get(Common.api + 'details-slider/' + id + '/' + i + '/' + j);
    },
    getAffiliatedProducts(id, i) {
        return axios.get(Common.api + 'seller-product-affs-only/' + id + '/' + i);
    },
    getProductsDetails(id, i) {
        return axios.get(Common.api + 'single-product/' + id + '/' + i);
    },
    getProductsList(id, i) {
        return axios.get(Common.api + 'category-product/' + id + '/' + i);
    },
    getProductsListTemp() {
        return axios.get(Common.api + 'category-product-temp');
    },
    getCategoryName(id) {
        return axios.get(Common.api + 'get-cat-name/' + id);
    },
    getAffiliatorProductsList(id, i) {
        return axios.get(Common.api + 'category-product-affs/' + id + '/' + i);
    },
    getAffiliatorProductsListTemp() {
        return axios.get(Common.api + 'category-product-affs-temp');
    },
    getSubProducts(id, i) {
        return axios.get(Common.api + 'subcategory-product/' + id + '/' + i);
    },
    getAffiliatorSubProducts(id, i) {
        return axios.get(Common.api + 'subcategory-product-affs/' + id + '/' + i);
    },
    getBudget() {
        return axios.get(Common.api + 'get-budget-list');
    },
    getSellerRequest(id) {
        return axios.get(Common.api + 'my-request-board/' + id)
    },
    getFavourite(id, i) {
        return axios.get(Common.api + 'add-to-favourite/' + id + '/' + i);
    },
    getRemoveFavourite(id, i) {
        return axios.get(Common.api + 'remove-from-favourites/' + id + '/' + i);
    },
    getFavouriteCounter(id, i) {
        return axios.get(Common.api + 'get-favourite-count/' + id + '/' + i);
    },
    // Sabik
    getProductList(id, i) {
        return axios.get(Common.api + 'seller-self-products/' + id + '/' + i);
    },

    getSearchResult(searchkey, i) {
        return axios.get(Common.api + 'search-result/' + searchkey + '/' + i);
    },
    //
    saveRequest(data) {
        return axios.post(Common.api + 'request-board', data);
    },
    create(data) {
        return axios.post(Common.api + 'upload-product', data);
    },
    // createResgistration1(data) {
    //     return axios.post(Common.api + 'seller-reg-first', data);
    // },
    // createResgistration2(data) {
    //     return axios.post(Common.api + 'seller-reg-second', data);
    // },
    update(id, data) {
        return axios.put(Common.api + 'seller-login' + id, data);
    },
    getNames(data) {
        return axios.post(Common.api + 'get-names-for-confs', data);
    },
    getRequestDetails(id, seller) {
        return axios.get(Common.api + 'request-details-purchase/' + id + '/' + seller)
    },
}
